module.exports = __webpack_public_path__ + "img/ecobanka_blanco.ea1eac7c.png";